import { LogEventAxiosInstance as axios } from 'api';
import getLocalStorageApi from 'api/browser/localstorage/get';
import { ErrorResponseHandler } from 'api/ErrorResponseHandler';
import { AxiosError } from 'axios';
import { LOCALSTORAGE } from 'constants/localStorage';
import { getLogAccessProfile } from 'pages/ScopedLogs/useLogAccess';
import { ErrorResponse, SuccessResponse } from 'types/api';
import { EventSuccessPayloadProps } from 'types/api/events/types';

const logEvent = async (
	eventName: string,
	attributes: Record<string, unknown>,
	eventType?: 'track' | 'group' | 'identify',
	rateLimited?: boolean,
): Promise<SuccessResponse<EventSuccessPayloadProps> | ErrorResponse> => {
	// Restricted profiles do not submit product analytics or private filters.
	// The server continues denying the event endpoint as an independent ceiling.
	if (getLogAccessProfile().restricted) {
		return {
			statusCode: 200,
			error: null,
			message: 'Analytics disabled for restricted profiles',
			payload: { status: 'skipped', data: '' },
		};
	}
	try {
		// add deployment_url and user_email to attributes
		const { hostname } = window.location;
		const userEmail = getLocalStorageApi(LOCALSTORAGE.LOGGED_IN_USER_EMAIL);
		const updatedAttributes = {
			...attributes,
			deployment_url: hostname,
			user_email: userEmail,
		};
		const response = await axios.post('/event', {
			eventName,
			attributes: updatedAttributes,
			eventType: eventType || 'track',
			rateLimited: rateLimited || false, // TODO: Update this once we have a proper way to handle rate limiting
		});

		return {
			statusCode: 200,
			error: null,
			message: response.data.status,
			payload: response.data.data,
		};
	} catch (error) {
		console.error(error);
		return ErrorResponseHandler(error as AxiosError);
	}
};

export default logEvent;
